import client, { PRIVATE_CLIENT } from '../../services/client';
export const getWidgetConfig = async () => {
    const response = await client.get('third-party/sdk/live-widget/setting/', PRIVATE_CLIENT);
    return response;
};
export const getLiveReceiver = async (public_key) => {
    return await client.post('third-party/sdk/live-widget/receiver-line/', PRIVATE_CLIENT, {
        public_key
    });
};
export const sendFeedback = async (data) => {
    return await client.post('third-party/sdk/live-widget/feedback/', PRIVATE_CLIENT, data);
};
